import {action, computed, observable} from 'mobx';
import { observer } from 'mobx-react';
import {
    autoinject,
    bind,
    inject, ModalHandle, ServicesAlert,
} from 'Mri.Web.Common';
import * as React from 'react';
import {AccountStore} from "../../../Account/AccountStore";
import {AppStore} from "../../../Core/AppStore";
import {IDisplayFieldProps} from "./DisplayFields";
import {DropdownToggle} from "reactstrap";
import {BsCaretDownFill} from "@react-icons/all-files/bs/BsCaretDownFill";
import {ContractModal} from "../../../Contracts/ContractModal";
import {ContractsStore} from "../../../Contracts/ContractsStore";

@autoinject
@observer
export class SerialNumberFieldContents extends React.Component<IDisplayFieldProps> {
    public render() {
        if (!this.display) return null;
        
        return (
            <div>
                <a href={`${this.accountStore.internalUrl}/displays/${this.display!.serialNumber}`} className="fw-bold"
                   target="_blank">
                    {this.display ? this.display.serialNumber : '-'}
                </a>
                <a onClick={this.handleClick} className="btn btn-link f-10 px-1 py-0"><BsCaretDownFill/></a>

                <ServicesAlert onClick={this.openContractModal} className="d-inline-block f-8" contract={this.contract} display={this.display} />

                {this.renderModals && this.contract && (
                    <ContractModal
                        contract={this.contract}
                        display={this.display}
                        modalHandle={this.contractModalHandle}
                        viewState="readOnly"
                    />
                )}
            </div>
        );
    }

    @bind
    @action
    private handleClick(e: React.MouseEvent) {
        e.preventDefault();
        let rowIndex = this.props.node.rowIndex;
        let column = this.props.column;
        if(column != undefined && rowIndex != null) {
            this.appStore.gridRef?.api.startEditingCell(
                {
                    rowIndex: rowIndex,
                    colKey: column,
                    // /** Set to `'top'` or `'bottom'` to start editing a pinned row */
                    //rowPinned: "bottom"
                    // /** The key to pass to the cell editor */
                    // key?: string;
                }
            )
        }

    }

    @computed
    private get contract() {
        if(this.display)
            return this.contractsStore.contracts.get(this.display.contract);
    }

    @computed
    private get display() {
        return this.props.data;
    }

    @bind
    @action
    private openContractModal() {
        this.renderModals = true;

        this.contractModalHandle.open();
    }

    @observable
    private renderModals = false;

    private contractModalHandle = new ModalHandle();
    @inject
    private accountStore!: AccountStore;
    @inject
    private appStore!: AppStore;
    @inject
    private contractsStore!: ContractsStore;
}
